import PageContainer from '../../../../components/common/PageContainer';
import MechanicTable from './MechanicTable';

function MechanicPage() {
  return (
    <>
      <PageContainer title='Personnel Databases' subTitle='Mechanic Master' showDate>
        Mechanic Master
        <MechanicTable />
      </PageContainer>
    </>
  );
}

export default MechanicPage;
